// User preferences API client. Phase 5.

import { api } from './api';
import type { Provider } from '@/types/api';

export interface Preferences {
  default_provider?: Provider;
  default_model?: string;
  language?: 'english' | 'hinglish' | 'hindi';
  verbosity?: 'concise' | 'balanced' | 'detailed';
  theme?: 'light' | 'dark' | 'system';
  auto_approve_safe_actions: boolean;
  custom_instructions?: string;
}

// Mirrors backend MaxCustomInstructionsChars (services/preferences_service.go).
export const MAX_CUSTOM_INSTRUCTIONS = 2000;

export async function getPreferences(): Promise<Preferences> {
  const { data } = await api.get<Preferences>('/api/v1/preferences');
  return data;
}

export async function updatePreferences(p: Partial<Preferences>): Promise<Preferences> {
  const { data } = await api.put<Preferences>('/api/v1/preferences', p);
  return data;
}
